import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
	selector: "ic-chip-button",
	templateUrl: "./button.component.html",
	styleUrls: ["./button.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChipButtonComponent {
	@HostBinding("class.active") @Input() active = false;
	@HostBinding("class.bordered") @Input() bordered = false;
	@HostBinding("class.dark") @Input() dark = false;
	@HostBinding("class.large") @Input() large = false;
	@HostBinding("class.danger") @Input() danger = false;
	@HostBinding("class.warning") @Input() warning = false;
	@HostBinding("class.loading") @Input() loading = false;
	@HostBinding("class.blue") @Input() blue = false;
	@HostBinding("class.large-contents") @Input() canContainLargeContents = false;

	@Output() action = new EventEmitter();

	@Input() disabled = false;
	@Input() clickable = true;
	@Input() help?: string;
}
